module.exports = __webpack_public_path__ + "static/img/gjgs1.b279816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/gjgs1.png
// module id = 0zeF
// module chunks = 1